import { render, staticRenderFns } from "./MenuRecursive.vue?vue&type=template&id=7d8a35b2&"
import script from "./MenuRecursive.vue?vue&type=script&lang=js&"
export * from "./MenuRecursive.vue?vue&type=script&lang=js&"
import style0 from "./MenuRecursive.vue?vue&type=style&index=0&id=7d8a35b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports